/*
Google Tag Manager - Custom Events
--------------------------------------------------------
This file contains all of the data-layer custom events.
*/

// Load functions.
document.addEventListener("DOMContentLoaded", () => {
  gtmProductView();
  gtmProductListViews();
  gtmProductClicks();
  gtmPlpAdClick();
  gtmBannerClick();
});

// EVENT: Product view (PDP).
function gtmProductView() {
  const container = document.querySelector('.product .product-form');
  if (!container) { return; }
  
  pushToGtm(
    'view_item',  // Event name
    getProductJson(container) // JSON
  );
};

// EVENT: Product list views.
function gtmProductListViews() {
  const productLists = [...document.querySelectorAll('[js-gtm-product-list]')];
  let timer;

  productLists.forEach((list) => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          timer = setTimeout(() => {
            pushToGtm(
              'view_item_list', // Event name
              getProductJson(list), // JSON
              getProductJson(list)[0]?.item_list_id, // List ID
              getProductJson(list)[0]?.item_list_name // List Name
            )
          }, 3000);

        } else {
          clearTimeout(timer);
        }
      })
    });

    observer.observe(list);
  });
};

// EVENT: Product clicks.
window.gtmProductClicks = function gtmProductClicks(container) {
  let products = [...document.querySelectorAll('.product-card')];

  if (container) {
    products = [...container.querySelectorAll('.product-card')];
  }

  products.forEach((product) => {
    product.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();

      pushToGtm(
        'select_item',  // Event name
        getProductJson(product), // JSON
        getProductJson(product)[0].item_list_id, // List ID
        getProductJson(product)[0].item_list_name // List Name
      );

      window.location.href = event.target.href;
    });
  });
};

// EVENT: Product add to cart.
window.gtmAddToCart = function gtmAddToCart(container) {
  let product = container.closest('.product-card');

  if (!product) {
    product = container.closest('.product-form');
  }

  pushToGtm(
    'add_to_cart',  // Event name
    getProductJson(product) // JSON
  );
};

// EVENT: Product remove from cart.
window.gtmRemoveFromCart = function gtmRemoveFromCart(container) {
  let product = container.closest('.cart-item');

  pushToGtm(
    'remove_from_cart',  // Event name
    getProductJson(product) // JSON
  );
};

// EVENT: View cart drawer.
window.gtmViewCart = function gtmViewCart(container) {
  if (!container) { return; }
  
  pushToGtm(
    'view_cart',  // Event name
    getProductJson(container) // JSON
  );
};

// EVENT: PLP ad click.
function gtmPlpAdClick() {
  const items = [...document.querySelectorAll('[js-gtm-plp-ad]')];

  items.forEach((item) => {
    const links = [...item.querySelectorAll('a')];

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        linkClick(event, item);
      });
    });
  });

  function linkClick(event, item) {
    event.preventDefault();
    const title = item.querySelector('.card__heading')?.textContent;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "plp_ad_click",
        "collection": item.getAttribute('js-gtm-plp-ad'),
        "content_title": title
    });

    window.location.href = event.target.href;
  }
}

// EVENT: Banner click.
function gtmBannerClick() {
  const items = [...document.querySelectorAll('[js-gtm-image-banner]')];

  items.forEach((item) => {
    const links = [...item.querySelectorAll('a')];

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        linkClick(event, item);
      });
    });
  });

  function linkClick(event, item) {
    event.preventDefault();
    const title = item.querySelector('.banner__heading')?.textContent?.trim();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "banner_click",
        "page": item.getAttribute('js-gtm-image-banner'),
        "content_title": title
    });

    window.location.href = event.target.href;
  }
}

// Get product JSON and return.
function getProductJson(data) {
  const items = [...data.querySelectorAll('[js-gtm-product-json]')];
  let json = [];

  items.forEach((item) => {
    json.push(JSON.parse(item.innerHTML));
  });

  return json;
}

// Push JSON and events to GTM.
function pushToGtm(eventName, json, listId, listName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ecommerce: null});

  if (listId && listName) {
    window.dataLayer.push({
      "event": eventName,
      "item_list_id": listId,
      "item_list_name": listName,
      "ecommerce": {
        "items": json
      }
    });
    return;
  }

  window.dataLayer.push({
    "event": eventName,
    "ecommerce": {
      "items": json
    }
  });
}
